import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PlumbingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Plumbing: React.FC<PlumbingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [plumbing, set_plumbing] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['Plumbing']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'Plumbing': [b.values?.['Major Systems']?.['Plumbing']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Plumbing (except fixtures)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(plumbing)}
                />
            ) : (
                <MoneyBox
                    id={'plumbing'}
                    allowNegative={false}
                    value={plumbing}
                    onChange={(value) => set_plumbing(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
